import { Stack } from '@mui/material';
import Loader from 'assets/animations/Loader';
import React from 'react';

const LoadingPage: React.FC = () => (
	<Stack
		direction="column"
		justifyContent="center"
		alignItems="center"
		height="100%"
	>
		<Loader />
	</Stack>
);

export default LoadingPage;
